var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',[_c('a-button',{attrs:{"type":"primary","icon":"desktop"},on:{"click":_vm.splitPane}},[_vm._v("点我分屏")]),_c('split-panel-modal',{ref:"splitPanelModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }